"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.notifyDark = exports.notifyWarning = exports.notifyInfo = exports.notifyError = exports.notifySuccess = exports.defaultProps = exports.TOAST_TYPES = exports.TOAST_POSITIONS = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactToastify = require("react-toastify");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const TOAST_POSITIONS = {
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  TOP_CENTER: 'top-center',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_CENTER: 'bottom-center'
};
exports.TOAST_POSITIONS = TOAST_POSITIONS;
const TOAST_TYPES = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  DARK: 'dark'
};
exports.TOAST_TYPES = TOAST_TYPES;
const defaultProps = {
  position: TOAST_POSITIONS.TOP_CENTER,
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true
};
exports.defaultProps = defaultProps;

const notify = (message, options) => {
  (0, _reactToastify.toast)(message, options);
};

const notifySuccess = function notifySuccess(message) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultProps;
  notify(message, _objectSpread(_objectSpread({}, options), {}, {
    type: TOAST_TYPES.SUCCESS
  }));
};

exports.notifySuccess = notifySuccess;

const notifyError = function notifyError(message) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultProps;
  notify(message, _objectSpread(_objectSpread({}, options), {}, {
    type: TOAST_TYPES.ERROR
  }));
};

exports.notifyError = notifyError;

const notifyInfo = function notifyInfo(message) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultProps;
  notify(message, _objectSpread(_objectSpread({}, options), {}, {
    type: TOAST_TYPES.INFO
  }));
};

exports.notifyInfo = notifyInfo;

const notifyWarning = function notifyWarning(message) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultProps;
  notify(message, _objectSpread(_objectSpread({}, options), {}, {
    type: TOAST_TYPES.WARNING
  }));
};

exports.notifyWarning = notifyWarning;

const notifyDark = function notifyDark(message) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultProps;
  notify(message, _objectSpread(_objectSpread({}, options), {}, {
    type: TOAST_TYPES.DARK
  }));
};

exports.notifyDark = notifyDark;
const Z_INDEX = 10000000;

const Toast = _ref => {
  let {
    position,
    autoClose,
    hideProgressBar,
    closeOnClick,
    pauseOnHover,
    draggable
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_reactToastify.ToastContainer, {
    position: position,
    autoClose: autoClose,
    hideProgressBar: hideProgressBar,
    closeOnClick: closeOnClick,
    pauseOnHover: pauseOnHover,
    draggable: draggable,
    style: {
      zIndex: Z_INDEX
    }
  });
};

Toast.propTypes = {
  position: _propTypes.default.string,
  autoClose: _propTypes.default.bool,
  hideProgressBar: _propTypes.default.bool,
  closeOnClick: _propTypes.default.bool,
  pauseOnHover: _propTypes.default.bool,
  draggable: _propTypes.default.bool
};
Toast.defaultProps = _objectSpread(_objectSpread({}, defaultProps), {}, {
  autoClose: true
});
Toast.helpers = {
  notifySuccess,
  notifyError,
  notifyInfo,
  notifyWarning,
  notifyDark
};
Toast.constants = {
  TOAST_POSITIONS,
  TOAST_TYPES
};
Toast.defaultProps = defaultProps;
var _default = Toast;
exports.default = _default;